import React from 'react';
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import {Stack, Typography} from "@mui/material";
import SpeakerPhoneIcon from "@mui/icons-material/SpeakerPhone";
import {useTranslation} from "react-i18next";
import {PointTemplatesTypeSingleVoyage} from "@containers/singleVoyage/pointTemplates/types";
import {sx} from './sx'

export const PointTemplateInfoSingleVoyage = ({
												  pointTemplate
											  }: {
	pointTemplate: {
		type: PointTemplatesTypeSingleVoyage
	}
}) => {
	const {t} = useTranslation()
	return (
		<Stack
			sx={sx.root}
			gap={'3px'}
			direction={'row'}
		>
			<Typography
				variant={'body2'}
				sx={sx.info}
			>
				<GpsFixedIcon fontSize={'small'}/>
				
				{t('base.pointTemplate')}
			</Typography>
			
			{pointTemplate?.type === 'RFID' && <Typography
                variant={'body2'}
                sx={sx.info}
            >
                <SpeakerPhoneIcon/>
				
				{t('base.rfid')}
            </Typography>}
		</Stack>
	);
};

